export const REGEX_NUMBER = '^[0-9]*$';
export const REGEX_ALPHANUMERIC = '^[^!\\"#$%&\\\'()*+,-.\\/:;<=>?@\\[\\]^_`{|}~]*$'; //^[^!"#$%&\\'()*+,-.\/:;<=>?@\[\]^_`{|}~]*$
export const REGEX_PASSWORD = '^(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@$!%*?&]*$';
export const REGEX_SITE = '^[a-z0-9_-]*$';
export const REGEX_PHONE = '([\\+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\\b';
export const REGEX_GMAIL = '^[a-z0-9](.?[a-z0-9]){0,}@g(oogle)?mail.com$';
export const REGEX_OUTLOOK =
  "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])";
